import { searchPlugin } from '@backstage/plugin-search';
import { createSearchResultListItemExtension } from '@backstage/plugin-search-react';

export const DocsV2SearchResultListItem = searchPlugin.provide(
  createSearchResultListItemExtension({
    name: 'DocsV2SearchResultListItem',
    component: () =>
      import('./DocsV2SearchResultListItemContent').then(
        m => m.DocsV2SearchResultListItemContent,
      ),
    predicate: result => result.type === 'docs-v2',
  }),
);
